<template>
     <el-row span="24">
        <el-col :span="24">
            <el-form ref="form" label-position="top">
                <el-row :gutter="25"> 
                    <el-col :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/video/Present')">
                            <el-select v-model="getSettingsVideo.present" :placeholder="$l('common/select')">
                                <el-option :label="$l('settings/video/No device')" value="0"></el-option>
                                <el-option :label="$l('settings/video/Video camera')" value="1"></el-option>
                            </el-select>
                            
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/video/Manual')">
                            <el-switch v-model="getSettingsVideo.manualrec" on-text="" off-text="" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/video/Triggering')">
                            <el-switch v-model="getSettingsVideo.audiotrig" on-text="" off-text="" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/video/Moving detection')">
                            <el-switch v-model="getSettingsVideo.movdetect" on-text="" off-text="" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="24">
                        <el-collapse accordion>
                            <el-collapse-item :title="$l('settings/video/Settings')">
                                <el-row> 
                                    <el-col>
                                        <el-form-item class="el-form-item-full" :label="$l('settings/video/Pre')">
                                            <el-select v-model="getSettingsVideo.pretime" :placeholder="$l('common/select')">
                                                <el-option value="0" label="no pre-record"></el-option>
                                                <el-option value="1" label="5s"></el-option>
                                                <el-option value="2" label="10s"></el-option>
                                                <el-option value="3" label="15s"></el-option>
                                                <el-option value="4" label="20s"></el-option>
                                                <el-option value="5" label="25s"></el-option>
                                                <el-option value="6" label="30s"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row> 
                                    <el-col>
                                        <el-form-item class="el-form-item-full" :label="$l('settings/video/Post')">
                                            <el-select v-model="getSettingsVideo.posttime" :placeholder="$l('common/select')">
                                                <el-option value="0" label="no post-record"></el-option>
                                                <el-option value="1" label="10s"></el-option>
                                                <el-option value="2" label="30s"></el-option>
                                                <el-option value="3" label="1min"></el-option>
                                                <el-option value="4" label="2min "></el-option>
                                                <el-option value="5" label="5min"></el-option>
                                                <el-option value="6" label="10min"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </el-collapse>
                        <!--Format SD -->
                        <el-dialog
                            title="Format SD"
                            :visible.sync="formatSDdialog"
                            size="tiny"
                            >
                            <span>{{$l('settings/device/formatSDdialog')}} </span>
                            <span slot="footer" class="dialog-footer">
                                    <el-button @click="formatSDdialog =  false"> {{$l('settings/alertMessaging/dialogCancel')}} </el-button>
                                    <el-button type="primary" @click="formatSDdialog =  false, formatSD()"> {{$l('settings/alertMessaging/dialogContinue')}} </el-button>
                            </span>
                        </el-dialog>
                        <el-row style="margin-top:20px">
                            <el-button :loading="formatSDLoading" type="danger" @click="formatSDdialog = true">{{$l('settings/device/Format')}}</el-button>
                            <el-button :loading="setDeviceLoading" type="info" @click="setDevice()">{{$l('settings/video/SetDevice')}}</el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </el-form>
        </el-col>
        
    </el-row>
</template>

<style>
  
</style>

<script>
import {formatVideoSD, saveSettings, setVideo} from '@/store/actions';
import { mapGetters } from 'vuex'
export default {
    data:function(){
        return{
            formatSDLoading : false,
            setDeviceLoading: false,
            formatSDdialog:false,
        }
    },
    computed:{
         ...mapGetters([
            'getSettingsVideo'
        ]),
    },
    methods:{
        setDevice(){
            this.setDeviceLoading = true;
            setTimeout(()=>{
            //api/set-video
             saveSettings(this.$store)
                .then((data)=>{
                    setVideo(this.$store)
                        .catch(()=>{})
                        .then((data)=>{
                            this.$message({
								type: 'success',
                                message: this.$l('settings/device/instrumentSent'),
								//message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
								//message: this.$l('settings/status/Restart success')
							});
                            this.setDeviceLoading = false;
                        })
                });
                
            },1500)
        },
        formatSD(){
            //api/sdformat-video
                this.formatSDLoading = true; 
            this.$notify({
                title: this.$l('common/Warning'),
                message: this.$l('settings/video/formatSDWarning'),
                type: 'warning'
            });    
             
            setTimeout(()=>{
                formatVideoSD(this.$store);
                    /*.catch(()=>{})
                    .then(()=>{
                        this.$message({
								type: 'success',
								message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
								//message: this.$l('settings/status/Restart success')
							});*/
                        this.formatSDLoading = false;
                    //})
                
            },1500)
        }
    }
}
</script>





// WEBPACK FOOTER //
// Video.vue?3cc8023c